import React, { useState } from 'react';
import { motion } from 'framer-motion';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';

interface Event {
  title: string;
  date: string;
  location: string;
  special?: string;
  backgroundColor: string;
  borderColor: string;
}

const scheduleEvents: Event[] = [
  {
    title: 'Lemonade Stand',
    date: '2025-07-05',
    location: 'Front Yard',
    special: 'Opening Day!',
    backgroundColor: '#FDE047',
    borderColor: '#FBBF24'
  },
  {
    title: 'Lemonade Stand',
    date: '2025-07-12',
    location: 'Park Entrance',
    special: 'Cupcake Day!',
    backgroundColor: '#FDA4AF',
    borderColor: '#FB7185'
  },
  {
    title: 'Lemonade Stand',
    date: '2025-07-19',
    location: 'Community Center',
    backgroundColor: '#FDE047',
    borderColor: '#FBBF24'
  },
  {
    title: 'Lemonade Stand',
    date: '2025-07-26',
    location: 'School Front',
    special: 'Banana Bread Special!',
    backgroundColor: '#FDA4AF',
    borderColor: '#FB7185'
  },
];

const SchedulePage: React.FC = () => {
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);

  const handleEventClick = (info: any) => {
    const eventId = info.event.id;
    const eventIndex = parseInt(eventId);
    setSelectedEvent(scheduleEvents[eventIndex]);
  };

  const renderEvents = () => {
    return scheduleEvents.map((event, index) => ({
      ...event,
      id: index.toString()
    }));
  };

  return (
    <div>
      <motion.h1 
        className="text-4xl font-baloo text-yellow-500 mb-8"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Our Schedule
      </motion.h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <motion.div 
          className="lg:col-span-2 card"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <FullCalendar
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            events={renderEvents()}
            eventClick={handleEventClick}
            height="auto"
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth'
            }}
          />
        </motion.div>

        <motion.div 
          className="card bg-yellow-50"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <h2 className="text-2xl font-baloo font-bold text-yellow-500 mb-4">
            Lemonade Stand Info
          </h2>
          
          {selectedEvent ? (
            <div className="space-y-3 font-comic">
              <p>
                <span className="font-bold">Date:</span> {new Date(selectedEvent.date).toLocaleDateString('en-US', { 
                  weekday: 'long',
                  month: 'long', 
                  day: 'numeric',
                  year: 'numeric'
                })}
              </p>
              <p>
                <span className="font-bold">Location:</span> {selectedEvent.location}
              </p>
              {selectedEvent.special && (
                <p className="text-pink-500 font-bold">
                  Special: {selectedEvent.special}
                </p>
              )}
              <div className="pt-4">
                <p className="font-baloo text-lg">Come visit us! We can't wait to see you!</p>
              </div>
            </div>
          ) : (
            <p className="font-comic">Click on a date to see details about our lemonade stand schedule!</p>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default SchedulePage; 